<script setup lang="ts">
import type { Story } from 'types/storyblok'

const storyblokStore = useStoryblokStore()
const route = useRoute()

const storySiblings = computed(() => storyblokStore.getStorySiblings(route))

function storyUrl(item: Story): string {
  let url
  if (item.lang) {
    const re = new RegExp(`^${item.lang}/`)
    url = item.full_slug.replace(re, '')
  }
  else {
    url = item.full_slug
  }
  return `/${url}`
}
</script>

<template>
  <nav class="page-submenu">
    <div class="scrollable">
      <ul class="list">
        <li
          v-for="sibling in storySiblings"
          :key="sibling.uuid"
        >
          <nuxt-link :to="storyUrl(sibling)">
            <span>
              {{ sibling.name }}
            </span>
          </nuxt-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<style lang="scss" scoped>
@import 'assets/scss/legacy/_variables.scss';
.page-submenu {
  padding: 1rem 0 0 0;
  font-size: 1.2rem;
  transition: all 0.2s ease-out;
}
.scrollable {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  @include hide-scrollbars;
}
.list {
  width: calc(100% + 1rem);
  text-align: left;
  display: flex;
  padding: 0 1rem;
  margin: 0 -0.5rem;
}
.router-link,
a {
  margin: 0 0.5rem;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  display: block;
  height: 3.6rem;
  line-height: 3.6rem;
  position: relative;
  span {
    padding: 0 1rem;
    display: block;
  }
  &:after {
    position: absolute;
    content: '';
    display: block;
    background: black;
    width: 100%;
    height: 0.3rem;
    bottom: 0;
    transform: translateY(0.3rem);
    transition: transform 0.2s ease-out;
  }
  &.nuxt-link-exact-active {
    &:after {
      transform: translateY(0);
    }
  }
}
a {
  white-space: nowrap;
}
// Laptop
@media screen and (min-width: $laptop) {
  .page-submenu {
    font-size: 1.3rem;
  }
  .scrollable .list {
    justify-content: center;
  }
}
</style>
